import { combineReducers } from "redux";
import theme from "./theme";
import global from "./global";
import { connectRouter } from "connected-react-router";
import login from "../containers/login/reducers";
import { createBrowserHistory as createHistory } from "history";
import pi from "../containers/publicinstrument/reducers/publicInstrumentReducer";
import setting from "../containers/setting/reducers/settingReducer";
import sessiondata from "../containers/connectionsessiondata/reducers/sessionDataActionReducer";
import providerErrorReducer from "../containers/errorMonitoring/reducers/index";
export const history = createHistory();

// export default (history)=> combineReducers({
//   theme,
//   global,
//   dashboard,
//   transaction,
//   valuation,
//   asset,
//   investment,
//   cash,
//   loan,
//   login,
//   setting,
//   security,
//   plaid: plaidReducer,
//   router: connectRouter(history)
// })

const appReducer = combineReducers({
  theme,
  global,
  login,
  router: connectRouter(history),
  pi,
  setting,
  sessiondata,
  provider: providerErrorReducer,
});

const rootReducer = (state, action) => {
  if (action && action.type === "LOGOUT") {
    let currentState = appReducer(state, action);
    let initialState = appReducer(undefined, action);
    if (initialState && initialState.theme) {
      initialState.theme.isMobile = currentState?.theme?.isMobile;
    }
    return initialState;
  } else {
    return appReducer(state, action);
  }
};

export default rootReducer;
